import React, {Component} from 'react';
import {Row, Col, Modal, Popconfirm, Radio, Checkbox, Tree, Button, Select} from 'antd';
import Card2 from '../../../components/Card2';
import {api, app} from "../../../app";
import command from "../../notice/command";

const TreeNode = Tree.TreeNode;
const Option = Select.Option;

class NewsReviewWhiteList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data1: [],
            data2: [],
            data3: [],
            level: "1",
            provinceList: [],
            proSelList: [],
            teamList: [],
            teamSelList: [],
            teamAllList: [],
            playerList: [],
            playerSelList: [],
            playerChecks: [],
            senObj: 1,
            audit: "",
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.dataSource();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 列表数据
     */
    dataSource = () => {
        this.setState({loading: true}, () => {
            const _this = this, params = {
                indexno: app.getData("indexno"),
                account: app.getData("account"),
            };
            app.post(api.NewsAuditListList, params).then(({flag, data, msg}) => {
                if (_this._isMounted) {
                    _this.setState({loading: false});
                    if (flag === 1) {
                        _this.setState({data1: data.one || [], data2: data.two || [], data3: data.three || []});
                    } else {
                        app.alert(msg, "error");
                    }
                }
            });
        });
    }


    /**
     * 添加审核人员
     * @param type
     */
    handleAdd = async () => {
        let {playerSelList, level, audit} = this.state;
        //队员
        if (!playerSelList || playerSelList.length === 0) {
            app.alert("请选择发布队员");
            return false;
        }

        const param = {
            audit,
            object: 1,
            grade: level,
            user: playerSelList.join(','),
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        };
        const {flag, msg} = await app.post(api.NewsAuditListAdd, param);
        if (this._isMounted) {
            if (flag === 1) {
                app.alert("添加成功", "success");
                this.CloseAddModal();
                this.dataSource();
            } else {
                app.alert(msg, "warn");
            }
        }
    }

    /**
     * 删除审核人员
     * @param type
     */
    handleDetele = async (id) => {
        const params = {
            id,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        };
        const {flag, msg} = await app.post(api.NewsAuditDelete, params);
        if (this._isMounted) {
            if (flag === 1) {
                app.alert("删除成功", "success");
                this.dataSource();
            } else {
                app.alert(msg, "error");
            }
        }
    }
    /**
     * 等级按钮组
     * @param level
     */
    handleBtnChange = (e) => {
        const {value} = e.target;
        if (this.state.level !== value) this.setState({level: value});
    }

    /**
     * 关闭添加弹框
     * @constructor
     */
    CloseAddModal = () => {
        this.setState({
            add_visible: false, proSelList: [], teamList: [], teamSelList: [], playerList: [],
            playerSelList: [], playerChecks: [], senObj: 1
        });
    }

    /**
     * 打开添加弹框
     * @constructor
     */
    OpenAddModal = async () => {
        const provinceList = await command.provinceData();
        const teamAllList = await command.teamAllData();
        this.setState({provinceList, teamAllList, add_visible: true});
    }

    /**
     * 发布对象上一步
     */
    handleObjPrev() {
        const {senObj} = this.state;
        this.setState({senObj: senObj - 1});
    }

    /**
     * 发布对象下一步
     */
    async handleObjNext() {
        let {senObj} = this.state;
        senObj++;
        switch (senObj) {
            case 2:
                let {proSelList} = this.state;
                proSelList = proSelList.join(',');
                if (!proSelList) {
                    app.alert("请选择省份!", "warn");
                    return false;
                }
                const teamList = await command.teamData(proSelList);
                this.setState({teamList, teamSelList: []});
                break;
            case 3:
                let {teamSelList} = this.state, list1 = [];
                teamSelList.forEach((team) => {
                    list1 = list1.concat(team.list);
                });
                list1 = list1.join(',');
                if (!list1) {
                    app.alert("请选择队伍!", "warn");
                    return false;
                }
                const playerList = await command.playerDataHT(list1);
                this.setState({playerList, playerSelList: [], playerChecks: []});
                break;
        }
        this.setState({senObj});
    }

    /**
     * 全部选择
     **/
    handleAllSel = (e, type) => {
        const {checked} = e.target;
        switch (type) {
            case 1:
                let {provinceList, proSelList} = this.state;
                if (checked) {
                    proSelList = provinceList.map((pro) => {
                        return pro.area_name;
                    });
                } else {
                    proSelList = [];
                }
                this.setState({proSelList});
                break;
            case 2:
                let {teamList, teamSelList} = this.state;
                if (checked) {
                    teamSelList = Object.keys(teamList).map((team) => {
                        return {
                            id: team,
                            list: teamList[team].map((t) => {
                                return t.teamno;
                            })
                        }
                    })
                } else {
                    teamSelList = [];
                }
                this.setState({teamSelList});
                break;
            case 3:
                let {playerSelList, playerList} = this.state;
                if (checked) {
                    playerSelList = Object.keys(playerList).map((p1) => {
                        return {
                            id: p1,
                            teamheader: (playerList[p1].teamheader || []).map((p) => {
                                return p.indexno;
                            }),
                            administrator: (playerList[p1].administrator || []).map((p) => {
                                return p.indexno;
                            }),
                            header_sel: true,
                            admin_sel: true,
                            p_sel: true,
                        };
                    });
                } else {
                    playerSelList = [];
                }
                this.setState({player_all: checked, playerSelList});
                break;
        }
    }

    /**
     * 选择
     * @param e
     * @param type
     * @param id
     */
    handleSel = (e, type, id) => {
        const {checked} = e.target;
        let {teamSelList, playerSelList, playerList} = this.state;
        switch (type) {
            case 1: //省份选择
                let {proSelList} = this.state;
                if (checked) {
                    proSelList.push(id);
                } else {
                    proSelList.splice(proSelList.indexOf(id), 1);
                }
                this.setState({proSelList});
                break;
            case 2: //队伍省份选择
                let {teamList} = this.state;
                if (checked) {
                    const tIndex = teamSelList.findIndex(v => v.id === id);
                    if (tIndex >= 0) {
                        teamSelList[tIndex].list = teamList[id].map((t) => {
                            return t.teamno;
                        });
                    } else {
                        teamSelList.push({
                            id,
                            list: teamList[id].map((t) => {
                                return t.teamno;
                            })
                        });
                    }
                } else {
                    teamSelList.splice(teamSelList.findIndex(value => value.id === id), 1);
                }
                this.setState({teamSelList});
                break;
            case 3://队伍选择
                let val = id.split('-');
                const v1 = teamSelList.findIndex(val1 => val1.id === val[0]);
                if (checked) {
                    if (v1 >= 0) {
                        teamSelList[v1].list.push(val[1]);
                    } else {
                        teamSelList.push({
                            id: val[0],
                            list: [val[1]]
                        });
                    }
                } else {
                    teamSelList[v1].list.splice(teamSelList[v1].list.indexOf(val[1]), 1);
                }
                this.setState({teamSelList});
                break;
            case 4://队员队伍选择
                let v2 = playerSelList.findIndex(val => val.id === id),
                    player_all = false;
                if (checked) {
                    let player = {
                        id,
                        teamheader: (playerList[id].teamheader || []).map((p) => {
                            return p.indexno;
                        }),
                        administrator: (playerList[id].administrator || []).map((p) => {
                            return p.indexno;
                        }),
                        header_sel: true,
                        admin_sel: true,
                        p_sel: true,
                    };
                    if (v2 >= 0) {
                        playerSelList[v2] = player;
                    } else {
                        playerSelList.push(player);
                    }
                    if (playerSelList.length === Object.keys(playerList).length) {
                        player_all = true;
                        playerSelList.forEach((p) => {
                            player_all = p.p_sel;
                        });
                    }
                } else {
                    if (v2 >= 0) {
                        playerSelList.splice(v2, 1);
                    }
                }
                this.setState({playerSelList, player_all});
                break;
            case 5://队员身份选择
                break;
        }
    }

    handleSel2 = (e, type) => {
        switch (type) {
            case 1:
                break;
            case 2:
                break;
            case 3:
                const playerSelList = [];
                e.forEach((c) => {
                    let arr = c.split('-ltjy-');
                    if (arr.length === 3 && playerSelList.indexOf(arr[2]) === -1) {
                        playerSelList.push(arr[2]);
                    }
                });
                this.setState({playerSelList, playerChecks: e});
                break;
        }
    }

    /**
     * 权限选择
     * @param e
     */
    handleGrageChange = (value) => {
        this.setState({audit: value.join(',')});
    }

    render() {
        const {data1, data2, data3, level, add_visible, proSelList, teamSelList, playerChecks, provinceList, teamList, playerList, playerSelList, senObj} = this.state,
            columns = [
                {
                    name: "姓名",
                    span: 3,
                    key: "vname",
                },
                {
                    name: "所属队伍",
                    span: 5,
                    key: "teamname",
                },
                {
                    name: "职位",
                    span: 5,
                    key: "teampositionname",
                    default: "暂无",
                },
                {
                    name: "审核权限",
                    span: 5,
                    key: "object_audit",
                    default: "暂无"
                },
                {
                    name: "操作",
                    span: 3,
                    render: (val, record) => {
                        return (
                            <Popconfirm title="确认删除吗？" onConfirm={() => this.handleDetele(record.id)} okText="是"
                                        cancelText="否">
                                <a href="#" className="link">删除</a>
                            </Popconfirm>
                        )
                    }
                }
            ],
            columns2 = [
                {
                    name: "姓名",
                    span: 4,
                    key: "vname",
                },
                {
                    name: "所属队伍",
                    span: 7,
                    key: "teamname",
                },
                {
                    name: "职位",
                    span: 5,
                    key: "teampositionname",
                    default: "暂无",
                },
                {
                    name: "操作",
                    span: 4,
                    render: (val, record) => {
                        return (
                            <Popconfirm title="确认删除吗？" onConfirm={() => this.handleDetele(record.id)} okText="是"
                                        cancelText="否">
                                <a href="#" className="link">删除</a>
                            </Popconfirm>
                        )
                    }
                }
            ];
        let prev_visable = senObj > 1,
            next_visable = senObj < 3,
            teamAll = false;
        if (teamSelList.length !== 0 && Object.keys(teamList).length === teamSelList.length) {
            teamAll = true;
            for (let t in teamList) {
                let i10 = teamSelList.findIndex(v => v.id === t);
                if (!i10 && i10 !== 0) {
                    teamAll = false;
                    break;
                }
                teamAll = teamSelList[i10].list.length === teamList[t].length;
                if (!teamAll) break;
            }
        }
        return (
            <div className="n-page notice-review-whitelist" style={{textAlign: 'center'}}>
                <div className="page-content">
                    <div className="btns">
                        <Radio.Group value={level} onChange={this.handleBtnChange}>
                            <Radio.Button value="1">一级审核</Radio.Button>
                            <Radio.Button value="2">二级审核</Radio.Button>
                            <Radio.Button value="3">三级审核</Radio.Button>
                        </Radio.Group>
                    </div>
                    <div className="cards" style={{height: "calc(100% - 32px)"}}>
                        {
                            level === "1" ?
                                (<Card2 style={{width: '80%'}} title="一级审核" titleLink="添加一级审核人员"
                                        data={data1} columns={columns}
                                        titleLinkClick={() => this.OpenAddModal()}/>) : null

                        }
                        {
                            level === "2" ?
                                (<Card2 style={{width: '80%'}} title="二级审核" titleLink="添加二级审核人员"
                                        data={data2} columns={columns}
                                        titleLinkClick={() => this.OpenAddModal()}/>) : null
                        }
                        {
                            level === "3" ?
                                (<Card2 style={{width: '80%'}} title="三级审核" titleLink="添加三级审核人员"
                                        data={data3} columns={columns2}
                                        titleLinkClick={() => this.OpenAddModal()}/>) : null
                        }
                    </div>
                    <Modal
                        visible={add_visible}
                        onCancel={this.CloseAddModal}
                        footer={null}
                        title={<div style={{textAlign: "center"}}>添加白名单</div>}
                        maskClosable={false}
                        destroyOnClose={true}
                        keyboard={false}
                        className="notice-release-send-modal"
                        width={1000}
                        zIndex={1002}
                        style={{top: 20}}
                    >
                        <div style={{color: "#faad14", fontSize: 12, marginBottom: 10}}>（由于数据量较大，可能导致速度较慢，请耐心等候~）</div>
                        {
                            senObj === 1 ?
                                (<div className="provices sel-item">
                                    <div className="title">选择省份</div>
                                    <div className="content">
                                        <div className="all-sel">
                                            <Checkbox onChange={(e) => this.handleAllSel(e, 1)}
                                                      checked={proSelList.length !== 0 && proSelList.length === provinceList.length}>全国</Checkbox>
                                        </div>
                                        <div className="list">
                                            {
                                                provinceList.map((pro, i) => {
                                                    return (
                                                        <Checkbox key={i}
                                                                  checked={proSelList.indexOf(pro.area_name) > -1}
                                                                  onChange={(e) => this.handleSel(e, 1, pro.area_name)}>{pro.area_name}</Checkbox>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>) : null
                        }
                        {
                            senObj === 2 ?
                                (<div className="teams sel-item">
                                    <div className="title">选择队伍</div>
                                    <div className="content">
                                        <div className="all-sel">
                                            <Checkbox onChange={(e) => this.handleAllSel(e, 2)}
                                                      checked={teamAll}>所有队伍</Checkbox>
                                        </div>
                                        <div className="list">
                                            {
                                                Object.keys(teamList).map((team, i) => {
                                                    return (
                                                        <div className="l-item" key={i}>
                                                            <div className="li-title">
                                                                <Checkbox
                                                                    checked={teamSelList.findIndex(val => val.id === team) >= 0 && teamSelList[teamSelList.findIndex(val => val.id === team)].list.length === teamList[team].length}
                                                                    onChange={(e) => this.handleSel(e, 2, team)}>{team}</Checkbox>
                                                            </div>
                                                            <div className="li-content">
                                                                {
                                                                    teamList[team].map((t1, i2) => {
                                                                        return (
                                                                            <Checkbox key={i2}
                                                                                      checked={teamSelList.findIndex(val => val.id === team) >= 0 ? teamSelList[teamSelList.findIndex(val => val.id === team)].list.indexOf(t1.teamno) >= 0 : false}
                                                                                      onChange={(e) => this.handleSel(e, 3, `${team}-${t1.teamno}`)}>{t1.teamname}</Checkbox>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>) : null
                        }
                        {
                            senObj === 3 ?
                                (
                                    <div className="players sel-item">
                                        <div className="title">
                                            <div>选择队员<span style={{
                                                marginLeft: 20,
                                                fontSize: 12
                                            }}>总选人数: {playerSelList.length}</span></div>
                                        </div>
                                        <div className="content">
                                            <Tree
                                                checkable
                                                onCheck={(e) => this.handleSel2(e, 3)}
                                                checkedKeys={playerChecks}
                                            >
                                                <TreeNode title="所有队员" key="0">
                                                    {
                                                        Object.keys(playerList).map((player) => {
                                                            return (
                                                                <TreeNode title={player} key={player}>
                                                                    {
                                                                        Object.keys(playerList[player]).map((sf) => {
                                                                            return playerList[player][sf].length > 0 ? (
                                                                                <TreeNode
                                                                                    title={command.checkSF(sf)}
                                                                                    key={`${player}-ltjy-${sf}`}>
                                                                                    {playerList[player][sf].map((p1) => {
                                                                                        return (
                                                                                            <TreeNode
                                                                                                title={p1.vname}
                                                                                                key={`${player}-ltjy-${sf}-ltjy-${p1.indexno}`}/>
                                                                                        )
                                                                                    })}
                                                                                </TreeNode>
                                                                            ) : null
                                                                        })
                                                                    }
                                                                </TreeNode>
                                                            )
                                                        })
                                                    }
                                                </TreeNode>
                                            </Tree>
                                        </div>
                                    </div>
                                ) : null
                        }
                        <div className="btns">
                            {prev_visable ? (
                                <Button onClick={() => this.handleObjPrev()}>上一步</Button>) : null}
                            {next_visable ? (
                                <Button onClick={() => this.handleObjNext()}>下一步</Button>) : null}
                            {senObj === 3 ? (
                                <Button onClick={() => this.handleAdd()}>添加</Button>) : null}
                        </div>
                    </Modal>
                </div>
            </div>
        );
    }
}

export default NewsReviewWhiteList;



// WEBPACK FOOTER //
// ./src/routes/ranks/News/NewsReviewWhiteList.jsx